import React, { useContext } from 'react';

import { AppContext } from './App';

import { _Title as Title } from './components/Styled/Title';
import { _Container as Container } from './components/Styled/Container';
import ProgressiveImage from './components/ProgressiveImage/ProgressiveImage';

import FormContent from './FormContent';

import './App.css';
import { _PageWrapper as PageWrapper, _TwoColumnLayout as TwoColumnLayout } from './App.style';
import { MarkdownWrapper } from './components/Styled/FormDescription';

const FormWrapper = () => {
  const { urlParams, localization, formAttributes, previewMode } = useContext(AppContext);

  const { name, img, description } = formAttributes;

  const imageSrc = img
    ? process.env.NODE_ENV === 'development'
      ? `http://localhost:1337${img.formats.small?.url || img.url}`
      : `${img.formats.medium?.url || img.url}`
    : '';
  const thumbnailSrc = img
    ? process.env.NODE_ENV === 'development'
      ? `http://localhost:1337${img.formats.thumbnail?.url || img.url}`
      : `${img.formats.thumbnail?.url || img.url}`
    : '';

  // Fallback width and height values
  const defaultWidth = 750;
  const defaultHeight = 750;

  return (
    <PageWrapper>
      {previewMode ? <pre>{localization.text.previewing}</pre> : ''}
      <Title>{name}</Title>
      <TwoColumnLayout>
        <Container width='50%' flexDirection='column' alignItems='center'>
          {img && (
            <ProgressiveImage
              placeholderSrc={thumbnailSrc}
              src={imageSrc}
              width={img.formats.medium?.width || defaultWidth}
              height={img.formats.medium?.height || defaultHeight}
              alt={img.alternativeText}
            />
          )}
          {description && <MarkdownWrapper>{description}</MarkdownWrapper>}
        </Container>

        <Container flexDirection='column'>
          <FormContent urlParams={urlParams} />
        </Container>
      </TwoColumnLayout>
    </PageWrapper>
  );
};

export default FormWrapper;
